import { Gender, Issues, Languages } from "../../Config/Expert";

const PROFESSION_LABELS: Record<string, string> = {
  clinical_psychologist: "Clinical Psychologist",
  psychiatrist: "Psychiatrist",
  counseling_psychologist: "Counseling Psychologist",
  creative_art_therapist: "Creative Art Therapist",
  yoga_or_meditation_expert: "Yoga or Meditation Expert",
  associate_clinical_psychologist: "Associate Clinical Psychologist",
  neuropsychologist: "Neuropsychologist",
  nutritionist: "Nutritionist",
};

const optionLabels = (values: string[] = [], options: any[]) =>
  (values || [])
    .map(
      (value) =>
        options.find((option) => option.value === value)?.label || value
    )
    .join(", ");

export const Information = ({ props }: any) => {
  const {
    first_name,
    whatsapp_phone_number,
    country_code,
    manoshala_email_id,
    address,
    longitude,
    latitude,
    city,
    state,
    country,
    pin_code,
    manoshala_id,
    onboarding_documents_folder_link,
    contract_documents_folder_link,
    service_page_link,
    role,
    date_of_birth,
    holds_professional_license,
    professional_license_details,
    outside_work,
    profession,
    top_expertise,
    all_expertise,
    profile_gender,
    highest_education,
    professional_certifications,
    practicing_experience_years,
    languages_known,
    profile_introduction,
    why_therapist,
    therapy_approach,
  } = props;

  return (
    <div className="col-sm-7">
      <h4>Personal Information</h4>
      <table className="table table-striped border-0 mt-4">
        <tbody>
          <tr>
            <th scope="row">Name:</th>
            <td colSpan={3}>{first_name}</td>
          </tr>
          <tr>
            <th scope="row">Role:</th>
            <td >{role}</td>
          </tr>
          <tr>
            <th scope="row">Date of Birth:</th>
            <td colSpan={3}>{date_of_birth}</td>
          </tr>
          <tr>
            <th scope="row">Professional License:</th>
            <td colSpan={3}>
              {holds_professional_license ? "Yes" : "No"}
              {holds_professional_license && professional_license_details
                ? ` — ${professional_license_details}`
                : ""}
            </td>
          </tr>
          <tr>
            <th scope="row">Outside Work:</th>
            <td colSpan={3}>{outside_work}</td>
          </tr>
          <tr>
            <th scope="row">Profession:</th>
            <td colSpan={3}>
              {PROFESSION_LABELS[profession] || profession || ""}
            </td>
          </tr>
          <tr>
            <th scope="row">Top 5 Areas of Expertise:</th>
            <td colSpan={3}>{optionLabels(top_expertise, Issues)}</td>
          </tr>
          <tr>
            <th scope="row">All Areas of Expertise:</th>
            <td colSpan={3}>{optionLabels(all_expertise, Issues)}</td>
          </tr>
          <tr>
            <th scope="row">Profile Gender:</th>
            <td colSpan={3}>{optionLabels(profile_gender ? [profile_gender] : [], Gender)}</td>
          </tr>
          <tr>
            <th scope="row">Highest Educational Qualification:</th>
            <td colSpan={3}>{highest_education}</td>
          </tr>
          <tr>
            <th scope="row">Professional Certifications:</th>
            <td colSpan={3}>
              {(professional_certifications || []).join(", ")}
            </td>
          </tr>
          <tr>
            <th scope="row">Practicing Experience (Years):</th>
            <td colSpan={3}>{practicing_experience_years}</td>
          </tr>
          <tr>
            <th scope="row">Languages Known:</th>
            <td colSpan={3}>{optionLabels(languages_known, Languages)}</td>
          </tr>
          <tr>
            <th scope="row">Profile Introduction:</th>
            <td colSpan={3}>{profile_introduction}</td>
          </tr>
          <tr>
            <th scope="row">Why Therapist:</th>
            <td colSpan={3}>{why_therapist}</td>
          </tr>
          <tr>
            <th scope="row">Approach in Therapy:</th>
            <td colSpan={3}>{therapy_approach}</td>
          </tr>
          <tr>
            <th scope="row">Whatsapp Phone Number:</th>
            <td colSpan={3}>{whatsapp_phone_number}</td>
          </tr>
          <tr>
            <th scope="row">Manoshala Email Id:</th>
            <td colSpan={3}>{manoshala_email_id}</td>
          </tr>
          <th scope="row">Manaoshala Id:</th>
          <td>{manoshala_id}</td>
          <tr>
            <th scope="row">Service Page Link:</th>
            <td colSpan={3}>{service_page_link}</td>
          </tr>
          <tr>
            <th scope="row">Address :</th>
            <td colSpan={3}>{address}</td>
          </tr>
          <tr>
            <th scope="row">Latitude :</th>
            <td colSpan={3}>{latitude}</td>
          </tr>
          <tr>
            <th scope="row">Longitude :</th>
            <td colSpan={3}>{longitude}</td>
          </tr>
          <tr>
            <th scope="row">City:</th>
            <td>{city}</td>
            <th scope="row">State:</th>
            <td>{state}</td>
          </tr>
          <tr>
            <th scope="row">Country:</th>
            <td>{country}</td>
            <th scope="row">Pin Code:</th>
            <td>{pin_code}</td>
          </tr>
          <tr>
            <th scope="row">Onboarding Document Link:</th>
            <td colSpan={3}>{onboarding_documents_folder_link}</td>
          </tr>
          <tr>
            <th scope="row">Contract Document Link:</th>
            <td colSpan={3}>{contract_documents_folder_link}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
